import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import IndexDesktopView from './components/IndexDesktopView'
import FilterChartPanel from './components/FilterChartPanel'
import SalesFilterPanel from './components/SalesFilterPanel'
import { loadAllCriticalComponentsDashboard, loadDynamicFilterOptions, downloadCriticalComponentsReport } from '../../store/criticalComponents/criticalComponentsActions'
import { loadAllSalesDashboard, downloadSalesReport, downloadComparativeReport } from '../../store/sales/salesAction'
import { buildSelectOptions } from '../../store/helpers/SelectOptions'
import moment from 'moment'

const Index = () => {
	const dispatch = useDispatch()
	let location = useLocation()
	let history = useHistory()

	const userProfile = useSelector((state) => state.session.get('profile'))
	const criticalComponentsDashboard = useSelector((state) => state.criticalComponents.get('criticalComponentsDashboard'))
	const salesDashboard = useSelector((state) => state.sales.get('salesDashboard'));

	const [filters, setFilters] = useState({
		year: [],
		month: [],
		models: [],
		gae: [],
		nomSol: [],
		materialPt: [],
		fault: [],
		failure: [],
		salesModel: [],
	})
	const [lateralPanelFilterState, setLateralPanelFilterState] = useState({
		open: false
	})
	const [salesPanelFilterState, setSalesPanelFilterState] = useState({
		open: false
	})
	const [filterOptionsLoaded, setFilterOptionsLoaded] = useState(false)
	const [selectedDate, setSelectedDate] = useState(() => {
		const today = new Date();
		return today.toISOString().split('T')[0]; // YYYY-MM-DD
	})
	const [salesDateRange, setSalesDateRange] = useState({
		startDate: moment().startOf('year'),
		endDate: moment(),
	})
	const [comparativeDateRange, setComparativeDateRange] = useState({
		startDate: moment().startOf('year'),
		endDate: moment(),
	})

	const onChangeLocation = (location) => history.push(location)

	const onChangeFilterByYear = (year) => {
		updateUrlFilters({
			year: [year],
			month: [] // reset meses
		})
	}
	/**Delete all filters */
	const deleteAllFilter = () => {
		let queryParams = queryString.parse(location.search)
		queryParams = {}
		history.push({ search: queryString.stringify(queryParams, { encode: false }) })
	}

	const updateUrlFilters = (newFilters) => {
		const queryParams = queryString.parse(location.search)

		const finalParams = { ...queryParams }

		const normalizeFilterValue = (value) => {
			if (Array.isArray(value)) {
				return value
			}
			if (value === undefined || value === null) {
				return []
			}
			return [value]
		}
		Object.keys(newFilters).forEach((key) => {
			const existing = normalizeFilterValue(finalParams[key])
			const toAdd = normalizeFilterValue(newFilters[key])
			// Merge and deduplicate
			finalParams[key] = Array.from(new Set([...existing, ...toAdd]))
		})

		// Remove empty arrays
		Object.keys(finalParams).forEach((key) => {
			if (Array.isArray(finalParams[key]) && finalParams[key].length === 0) {
				delete finalParams[key]
			}
		})

		history.push({
			search: queryString.stringify(finalParams, { encode: false })
		})
	}
	// Load filter options only on initial mount
	// useEffect(() => {
	// 	dispatch(loadCriticalComponentsFilterOptions())
	// }, [dispatch])

	// Load dynamic filter options
	useEffect(() => {
		const loadOptions = async () => {
			await dispatch(loadDynamicFilterOptions('SerialYear', 'Serial_Year', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('Model', 'Model', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('GAE', 'GAE', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('NomSol', 'NOM_SOL', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('MaterialPt', 'MATERIAL_PT', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('Fault', 'FAULT', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('Failure', 'FAILURE', 'ViewCriticalComponents'))
			await dispatch(loadDynamicFilterOptions('Modelo', 'MODELO', 'ViewSales'))
			await dispatch(loadDynamicFilterOptions('Sku', 'SKU', 'ViewSales'))
			setFilterOptionsLoaded(true)
		}
		loadOptions()
	}, [dispatch])

	// Only load dashboard data when filter options are loaded
	useEffect(() => {
		if (!filterOptionsLoaded) return
		const params = queryString.parse(location.search)

		const newFilters = {
			year: params.year ? (Array.isArray(params.year) ? params.year.map(String) : [String(params.year)]) : [],
			month: params.month ? (Array.isArray(params.month) ? params.month.map(Number) : [Number(params.month)]) : [],
			model: params.model ? (Array.isArray(params.model) ? params.model : [params.model]) : [],
			gae: params.gae ? (Array.isArray(params.gae) ? params.gae : [params.gae]) : [],
			nomSol: params.nomSol ? (Array.isArray(params.nomSol) ? params.nomSol : [params.nomSol]) : [],
			materialPt: params.materialPt ? (Array.isArray(params.materialPt) ? params.materialPt : [params.materialPt]) : [],
			fault: params.fault ? (Array.isArray(params.fault) ? params.fault : [params.fault]) : [],
			failure: params.failure ? (Array.isArray(params.failure) ? params.failure : [params.failure]) : [],
			salesModel: params.salesModel ? (Array.isArray(params.salesModel) ? params.salesModel : [params.salesModel]) : [],
		}

		setFilters(newFilters)
		dispatch(loadAllCriticalComponentsDashboard({
			...newFilters,
			CompletionDate: selectedDate
		}))
	}, [location.search, dispatch, filterOptionsLoaded, selectedDate])

	// Helper to parse sales-relevant filters from URL
	const parseSalesFilters = () => {
		const params = queryString.parse(location.search)
		return {
			year: params.year ? (Array.isArray(params.year) ? params.year.map(String) : [String(params.year)]) : [],
			month: params.month ? (Array.isArray(params.month) ? params.month.map(Number) : [Number(params.month)]) : [],
			materialPt: params.materialPt ? (Array.isArray(params.materialPt) ? params.materialPt : [params.materialPt]) : [],
			salesModel: params.salesModel ? (Array.isArray(params.salesModel) ? params.salesModel : [params.salesModel]) : [],
		}
	}

	// Separate effect for sales data — avoids re-triggering critical components on date range changes
	// and skips intermediate picks where startDate === endDate (user clicked only the first date)
	const salesStartStr = salesDateRange.startDate?.format('YYYY-MM-DD')
	const salesEndStr = salesDateRange.endDate?.format('YYYY-MM-DD')
	const compStartStr = comparativeDateRange.startDate?.format('YYYY-MM-DD')
	const compEndStr = comparativeDateRange.endDate?.format('YYYY-MM-DD')
	useEffect(() => {
		if (!filterOptionsLoaded) return
		if (salesStartStr === salesEndStr) return
		dispatch(loadAllSalesDashboard({ ...parseSalesFilters(), salesDateRange, comparativeDateRange }))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [salesStartStr, salesEndStr, dispatch, filterOptionsLoaded])

	// Reload when comparative date range changes
	useEffect(() => {
		if (!filterOptionsLoaded) return
		if (compStartStr === compEndStr) return
		dispatch(loadAllSalesDashboard({ ...parseSalesFilters(), salesDateRange, comparativeDateRange }))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [compStartStr, compEndStr, dispatch, filterOptionsLoaded])

	// Also reload sales when URL filters change (but not on date range changes)
	useEffect(() => {
		if (!filterOptionsLoaded) return
		dispatch(loadAllSalesDashboard({ ...parseSalesFilters(), salesDateRange, comparativeDateRange }))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search, dispatch, filterOptionsLoaded])

	// Handler for date change
	const handleDateChange = (event) => {
		setSelectedDate(event.target.value)
	}

	const handleSalesDateRangeChange = ({ startDate, endDate }) => {
		setSalesDateRange({ startDate, endDate })
	}

	const handleComparativeDateRangeChange = ({ startDate, endDate }) => {
		setComparativeDateRange({ startDate, endDate })
	}

	const deleteAllComparativeFilter = () => {
		const queryParams = queryString.parse(location.search)
		delete queryParams.materialPt
		history.push({ search: queryString.stringify(queryParams, { encode: false }) })
		setComparativeDateRange({ startDate: moment().startOf('year'), endDate: moment() })
	}

	const onClickSalesFilterChart = () => {
		setSalesPanelFilterState((prev) => ({ ...prev, open: !prev.open }))
	}

	const deleteAllSalesFilter = () => {
		const queryParams = queryString.parse(location.search)
		delete queryParams.salesModel
		delete queryParams.materialPt
		history.push({ search: queryString.stringify(queryParams, { encode: false }) })
		setSalesDateRange({ startDate: moment().startOf('year'), endDate: moment() })
	}

	const onChangeFilterByMonth = (month) => {
		updateUrlFilters({
			month: [month]
		})
	}

	const onClickFilterChart = () => {
		setLateralPanelFilterState({
			...lateralPanelFilterState,
			open: !lateralPanelFilterState.open
		})
	}

	const onChangeFilterByModel = (model) => {
		updateUrlFilters({
			model: [model]
		})
	}

	const onChangeFilterBySalesModel = (salesModel) => {
		updateUrlFilters({
			salesModel: [salesModel]
		})
	}

	const onChangeFilterByGae = (gae) => {
		updateUrlFilters({
			gae: [gae]
		})
	}

	const onChangeFilterByNomSol = (nomSol) => {
		updateUrlFilters({
			nomSol: [nomSol]
		})
	}

	const onChangeFilterByMaterialPt = (materialPt) => {
		updateUrlFilters({
			materialPt: [materialPt]
		})
	}

	const onChangeFilterByFault = (fault) => {
		updateUrlFilters({
			fault: [fault]
		})
	}

	const onChangeFilterByFailure = (failure) => {
		updateUrlFilters({
			failure: [failure]
		})
	}

	const onDownloadFailureReport = async () => {
		try {
			const filtersWithDate = { ...filters, CompletionDate: selectedDate }
			const arrayBuffer = await dispatch(downloadCriticalComponentsReport(filtersWithDate))
			const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const url = window.URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href = url
			a.download = 'CriticalComponentsReport.xlsx'
			document.body.appendChild(a)
			a.click()
			a.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Failed to download critical components report:', error)
			// Optionally show a user notification here
		}
	}

	const onDownloadSalesReport = async () => {
		try {
			const arrayBuffer = await dispatch(downloadSalesReport({ ...parseSalesFilters(), salesDateRange, comparativeDateRange }))
			const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const url = window.URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href = url
			a.download = 'SalesReport.xlsx'
			document.body.appendChild(a)
			a.click()
			a.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Failed to download sales report:', error)
			// Optionally show a user notification here
		}
	}

	const onDownloadComparativeReport = async () => {
		try {
			const arrayBuffer = await dispatch(downloadComparativeReport({ ...parseSalesFilters(), salesDateRange, comparativeDateRange }))
			const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const url = window.URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href = url
			a.download = 'ComparativeReport.xlsx'
			document.body.appendChild(a)
			a.click()
			a.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Failed to download comparative report:', error)
			// Optionally show a user notification here
		}
	}

	/**
	 * Load services list
	 */
	const onFilterOptionClick = (field, value) => {
		updateUrlFilters({
			[field]: [value]
		})
	}

	const onRemoveFilterOption = (field, value) => {
		const queryParams = queryString.parse(location.search)
		let current = queryParams[field]
		if (!current) return
		if (!Array.isArray(current)) current = [current]
		const updated = current.filter(v => String(v) !== String(value))
		if (updated.length > 0) {
			queryParams[field] = updated
		} else {
			delete queryParams[field]
		}
		history.push({ search: queryString.stringify(queryParams, { encode: false }) })
	}

	const yearsOptions = useSelector((state) => state.criticalComponents.get('SerialYearOptions'))
	const modelsOptions = useSelector((state) => state.criticalComponents.get('ModelOptions'))
	const gaeOptions = useSelector((state) => state.criticalComponents.get('GAEOptions'))
	const nomSolOptions = useSelector((state) => state.criticalComponents.get('NomSolOptions'))
	const materialPtOptionsImmutable = useSelector((state) => state.criticalComponents.get('MaterialPtOptions'))
	const faultsOptions = useSelector((state) => state.criticalComponents.get('FaultOptions'))
	const failuresOptions = useSelector((state) => state.criticalComponents.get('FailureOptions'))
	const salesModelOptions = useSelector((state) => state.criticalComponents.get('ModeloOptions'))
	const skuOptions = useSelector((state) => state.criticalComponents.get('SkuOptions'))

	const yearsArray = buildSelectOptions(yearsOptions, (code, desc) => desc || String(code)).filter(opt => opt.value && String(opt.value).trim() !== '');
	const modelsArray = buildSelectOptions(modelsOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '');
	const gaeArray = buildSelectOptions(gaeOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '');
	const nomSolArray = buildSelectOptions(nomSolOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '');
	const materialPtOptions = buildSelectOptions(materialPtOptionsImmutable, (code) => code.replace(/^0+/, '')).filter(opt => opt.value && String(opt.value).trim() !== '');
	const faultsArray = buildSelectOptions(faultsOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '')
	const failuresArray = buildSelectOptions(failuresOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '');
	const salesModelArray = buildSelectOptions(salesModelOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '');
	const skusArray = buildSelectOptions(skuOptions, (code, desc) => desc || code).filter(opt => opt.value && String(opt.value).trim() !== '');

	return (
		<>
			<IndexDesktopView
				criticalComponentsDashboard={criticalComponentsDashboard}
				userProfile={userProfile}
				onClickFilterChart={onClickFilterChart}
				onClickSalesFilterChart={onClickSalesFilterChart}
				filters={filters}
				onChangeLocation={onChangeLocation}
				onChangeFilterByYear={onChangeFilterByYear}
				onChangeFilterByMonth={onChangeFilterByMonth}
				onChangeFilterByModel={onChangeFilterByModel}
				onChangeFilterBySalesModel={onChangeFilterBySalesModel}
				onChangeFilterByGae={onChangeFilterByGae}
				onChangeFilterByNomSol={onChangeFilterByNomSol}
				onChangeFilterByMaterialPt={onChangeFilterByMaterialPt}
				onChangeFilterByFault={onChangeFilterByFault}
				onChangeFilterByFailure={onChangeFilterByFailure}
				onDeleteAllFilter={deleteAllFilter}
				onDeleteAllSalesFilter={deleteAllSalesFilter}
				selectedDate={selectedDate}
				onDateChange={handleDateChange}
				onDownloadFailureReport={onDownloadFailureReport}
				onDownloadSalesReport={onDownloadSalesReport}
				onDownloadComparativeReport={onDownloadComparativeReport}
				salesDashboard={salesDashboard}
				salesDateRange={salesDateRange}
				onSalesDateRangeChange={handleSalesDateRangeChange}
				comparativeDateRange={comparativeDateRange}
				onComparativeDateRangeChange={handleComparativeDateRangeChange}
				onDeleteAllComparativeFilter={deleteAllComparativeFilter}
			/>
			{/* Only show FilterChartPanel as the lateral panel */}
			{lateralPanelFilterState.open && (
				<FilterChartPanel
					open={lateralPanelFilterState.open}
					onClose={onClickFilterChart}
					onDeleteAllFilter={deleteAllFilter}
					years={yearsArray}
					models={modelsArray}
					gae={gaeArray}
					nomSol={nomSolArray}
					materialPt={materialPtOptions}
					faults={faultsArray}
					failures={failuresArray}
					selectedYears={filters.year}
					selectedModels={filters.model}
					selectedGae={filters.gae}
					selectedNomSol={filters.nomSol}
					selectedMaterialPt={filters.materialPt}
					selectedFaults={filters.fault}
					selectedFailures={filters.failure}
					onFilterOptionClick={onFilterOptionClick}
					onRemoveFilterOption={onRemoveFilterOption}
				/>
			)}
			{salesPanelFilterState.open && (
				<SalesFilterPanel
					open={salesPanelFilterState.open}
					onClose={onClickSalesFilterChart}
					onDeleteAllFilter={deleteAllSalesFilter}
					salesModels={salesModelArray}
					skus={skusArray}
					selectedSalesModels={filters.salesModel}
					selectedSkus={filters.materialPt}
					onFilterOptionClick={onFilterOptionClick}
					onRemoveFilterOption={onRemoveFilterOption}
				/>
			)}
		</>
	)
}

export default Index
